export default {
  local: "français",
  interactivity: {
    chapters: "Chapitres",
    chapter: "Chapitre",
    Poll: "SONDAGE",
    yes: "Oui",
    no: "Non",
    quiz: "QUIZZ",
    dont_know: "Je ne sais pas",
    question: "QUESTION",
    sondage: "SONDAGE",
    chaptersList: "Liste des chapitres",
    attachment: "Fichiers joints",
    downloadAll: "Télécharger tout",
    options: "Choix",
  },
  player: {
    autoplay: "autoplay",
    audio: "Audio",
    auto: "Auto",
    buffered: "Tamponné",
    captions: "Captions",
    currentTime: "Temps actuel",
    slides: "Diapositives",
    duration: "Durée",
    enabled: "Activé",
    enterFullscreen: "Entrer en plein écran",
    enterPiP: "Miniplayer",
    exitFullscreen: "Quitter le plein écran",
    fullscreen: "Plein écran",
    live: "LIVE",
    loop: "Boucle",
    mute: "Mute",
    none: "Aucun",
    normal: "Normal",
    off: "Off",
    pip: "Picture-in-Picture",
    play: "Lecture",
    pause: "Pause",
    replay: "Relecture",
    playback: "lecture",
    playbackQuality: "Qualité de lecture",
    playbackRate: "Taux de lecture",
    played: "Joué",
    scrubberLabel: "{currentTime} de {duration}",
    adjustVol: "Régler le volume",
    advance: "Avance",
    fastBackward: "Recul rapide",
    subtitleSetting: "Paramètres des sous-titres",
    offlineVideo: "La vidéo est hors ligne",
    liveVideoDesc: "Le direct n'a pas encore commencé",
    srcprocessed: "La source vidéo est en cours de traitement",
    videoPause: "Suspendre la vidéo",
    link: "Lien"
  },
  modals: {
    moreInfo: "plus d'infos",
    about: "À PROPOS",
    quality: "Qualité",
    rate: "VITESSE",
    keyboardShortcuts: "RACCOURCIS CLAVIER",
    showListOfShortcuts: "Afficher la liste des raccourcis clavier",
    Closeallmodals: "Fermer tous les modals",
    default: "Défaut",
    disableCaptions: "Sous-titres transcrits désactivés",
    disabled: "Désactiver",
    enableCaptions: "Activer les sous-titres/captions",
    functions: "Fonctions",
    shortcuts: "Raccourcis",
  },
  buttons: {
    send: "Envoyer",
    Continue: "CONTINUER",
    close: "Fermer",
    seekBackward: "Reculer de",
    seekForward: "Avancer de",
    settings: "Paramètres",
    subtitlesOrCc: "Sous-titres/CC",
    unmute: "Démutez",
    volume: "Volume",
    confirm: "Confirmer",
    next: "suivant",
    download: "Télécharger",
    disableSubtitles: "sous-titres transcrits désactivés",
    share: "Partager",
    AD: "Audio/Description",
    rewind: "rembobiner",
    ignore: "Ignorer",
    valid: "Valider",
    rewindSec: "Reculer 10 sec",
    forwardSec: "Avançer 10 sec",
    descPlayer: "Description"
  },
  AllTraslation: {
    exitPiP: "Développez",
    searchChapter: "Chercher un chapitre",
    globalInfo: "Informations générales",
    socialMedia: "RÉSEAUX SOCIAUX",
    exportVideo: "EXPORTER LA VIDÉO",
    sendWithMail: "ENVOYER PAR MAIL",
    shareOn: "Partager sur",
    permalink: "permalien",
    copy: "copier",
    embedCode: "Code Embed",
    color: "Couleur",
    startAt: "démarrer à",
    yourEmail: "Votre email",
    receiverEmail: "Email du destinataire",
    message: "Message",
    emailExample: "example@example.com",
    writeYourMsg: "écrivez votre message ici...",
    spaceBar: "Espace",
    or: "ou",
    seconds: "secondes",
    scrubber: "Épurateur",
    seekTotal: "Chercher le total",
    video: "Vidéo",
    viewport: "Fenêtre",
    resolution: "Résolution actuelle",
    codec: "Codec",
    host: "Hôte",
    speed: "Vitesse de connexion",
    repeat: "Répéter",
    statistics: "Statistiques",
    powered: "Alimenté par",
    continue: "Continuer",
    authentication: "Authentification",
    textAuth: "Vous devez saisir le mot de passe pour voir ce vidéo",
    NotfoundPage: "Média non trouvée",
    NotfoundPageDesc: "Le média que vous tentez d’afficher n’existe pas",
    AccessDenied: "Accès interdit",
    AccessDeniedDesc: "Le serveur refuse d'exécuter cette requête",
    AuthRequired: "Authentification requise",
    NeedAuth:
      "Veuillez vous authentifier sur la plateforme pour continuer la vidéo",
    shuffle: "mélanger",
    playlist: "Playliste",
    searchPlaylist: "Recherche",
    viewPDF: "Consulter le pdf",
  },
};
